import React, { useState } from 'react';

import { connect } from 'react-redux';

import { buildEmptyProperty } from './helper';
import InsightsSuggestedAddressModal from './suggested_address_modal';
import InsightsSearchModal from './search_modal';
import Modal from 'components/modal';
import { oneLine } from 'helpers/formatters/address_formats';
import { pick } from 'lodash';
import { post } from 'helpers/api';

import type { Country } from 'bundles/research/index/types';

interface NewPropertyModalProps {
  countryList: Country[];
  newPropertyPath: string;
  show: boolean;
  onHide: () => void;
}

export function NewPropertyModal({
  countryList,
  newPropertyPath,
  show,
  onHide,
}: NewPropertyModalProps) {
  const [searchMessage, setSearchMessage] = useState<string>();
  const [suggestedProperties, setSuggestedProperties] = useState([]);
  const [property, setProperty] = useState(buildEmptyProperty(countryList));

  const changeProperty = (change) => {
    const newProperty = { ...property, ...change };
    setProperty(newProperty);
  };

  const getPropertyParams = (property) => {
    const fields = ['address', 'city'];
    if (property.country?.countryStates?.length) {
      fields.push('state');
    }
    if (property.country?.zipLabel) {
      fields.push('zip');
    }
    return pick(property, fields);
  };

  const createProperty = (property) => {
    let params;
    if (property.insights_id) {
      params = pick(property, ['insights_id']);
    } else {
      params = { ...getPropertyParams(property), country_id: property.country.id };
    }
    const urlParams = new URLSearchParams(params);
    window.location.href = `${newPropertyPath}?${urlParams.toString()}`;
  };

  const reset = () => {
    setSearchMessage('');
    setSuggestedProperties([]);
    setProperty(buildEmptyProperty(countryList));
  };

  const handlePropertySearch = async () => {
    
    const body = {
      insights_property: getPropertyParams(property),
      only: ['address', 'city', 'state', 'zip', 'propertyId']
    };
    const insightResponse = await post('/insights_properties/search', body);

    if (insightResponse['total'] === 0) {
      setSearchMessage(`The address ${oneLine(property)} was not found in Insights. Creating new property.`);
      createProperty(property);
    } else {
      setSuggestedProperties(insightResponse['hits']);
    }
  };

  return (
    <Modal show={show} onHide={onHide} onShow={reset}>
      {suggestedProperties?.length
        ? (
          <InsightsSuggestedAddressModal
            property={property}
            suggestedProperties={suggestedProperties}
            onHide={() => setSuggestedProperties([])}
            onSave={createProperty}
          />
        )
        : (
          <InsightsSearchModal
            countryList={countryList}
            info={searchMessage}
            property={property}
            onChange={changeProperty}
            onHide={onHide}
            onSearch={handlePropertySearch}
          />
        )}
    </Modal>
  );
}

const mapStateToProps = state => ({
  countryList: state.static.countryList,
});

export default connect(mapStateToProps)(NewPropertyModal);
